/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { useEffect } from "react";

import { useAccountStore } from "./account.hooks";

declare global {
	interface Window {
		/** Read by tracking.js on every event; takes precedence over its SSO-cookie lookup. */
		_epicAccountId?: string;
	}
}

/**
 * Keeps `window._epicAccountId` matching the account after the page has loaded.
 *
 * The `account` prop of `Tracking` (`@cosmos/next-common`) covers the first page
 * view, but the account can change without a reload: the `useAuth` session check
 * can sign in a page that rendered signed out, and its focus revalidation picks up
 * a sign-in or sign-out from another tab. Must sit inside `AccountProvider`.
 */
export function TrackingAccountIdSync(): null {
	const { account } = useAccountStore();
	const accountId = account.isLoggedIn ? account.id : undefined;

	useEffect(() => {
		if (accountId) {
			window._epicAccountId = accountId;
		} else {
			delete window._epicAccountId;
		}
	}, [accountId]);

	return null;
}
